import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    height: "80px",
    padding: "0px 56px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid #DDD",
    background: "rgba(255, 255, 255, 0.90)",
    backdropFilter: "blur(12px)",
  },
  responsiveStyles: {
    tablet: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
    mobile: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
  },
  children: [
    // Logo
    {
      id: generateId(),
      type: "logo" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/logo.png", // <-- Update this path to your logo
          alt: "Logo",
          styles: {
            width: "48px",
            height: "48px",
            objectFit: "contain",
          },
        },
      ],
    },
    // Button
    {
      id: generateId(),
      type: "button" as ElementType,
      content: "Jetzt Bestellen",
      styles: {
        display: "flex",
        height: "48px",
        padding: "0px 28px",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        borderRadius: "60px",
        backgroundColor: "secondary",
        boxShadow: "0px 0px 0px 4px rgba(16, 31, 15, 0.10)",
        color: "#FFFFFF",
        fontWeight: "500",
        fontSize: "18px",
        border: "none",
        margin: "0 0 0 auto",
      },
    },
  ],
});

const createPrivacyIntroSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "48px 0 0 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundColor: "background",
    boxSizing: "border-box",
    gap: "18px",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "32px 0 0 0",
    },
    mobile: {
      maxWidth: "95%",
      padding: "24px 0 0 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content: "Allgemeine Geschäftsbedingungen (AGB)",
      styles: {
        fontFamily: "Open Sans",
        fontSize: "44px",
        fontWeight: "700",
        color: "forground",
        marginBottom: "0",
        lineHeight: "150%",
      },
      responsiveStyles: {
        tablet: { fontSize: "32px" },
        mobile: { fontSize: "26px" },
      },
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "0",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "für die Nutzung von klosterformel.com sowie den Erwerb der darüber angebotenen Produkte",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "20px",
            fontWeight: "700",
            color: "forground",
            marginBottom: "0",
          },
          typography: "Heading-6",
          responsiveStyles: {
            tablet: { fontSize: "18px" },
            mobile: { fontSize: "18px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Betreiber: Vital Today LLC",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "20px",
            fontWeight: "700",
            color: "forground",
            marginBottom: "0",
          },
          typography: "Heading-6",
          responsiveStyles: {
            tablet: { fontSize: "18px" },
            mobile: { fontSize: "18px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "📍 3798 Brookstone Drive, Columbus, OH 43235, United States",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "20px",
            fontWeight: "700",
            color: "forground",
            marginBottom: "0",
          },
          typography: "Heading-6",
          responsiveStyles: {
            tablet: { fontSize: "18px" },
            mobile: { fontSize: "18px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "📧 E-Mail: hello@klosterformel.com",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "20px",
            fontWeight: "700",
            color: "forground",
            marginBottom: "0",
          },
          typography: "Heading-6",
          responsiveStyles: {
            tablet: { fontSize: "18px" },
            mobile: { fontSize: "18px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Zahlungsabwicklung: Digistore24 GmbH, St.-Godehard-Str. 32, 31139 Hildesheim, Deutschland",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "20px",
            fontWeight: "700",
            color: "forground",
            marginBottom: "0",
          },
          typography: "Heading-6",
          responsiveStyles: {
            tablet: { fontSize: "18px" },
            mobile: { fontSize: "18px" },
          },
        },
      ],
    },
  ],
});

const pointersContent = [
  {
    title: "1 – Geltungsbereich, Definitionen, Vertragsgegenstand",
    text: `1.1. Die nachstehenden allgemeinen Geschäftsbedingungen (AGB) regeln das Zustandekommen, den Inhalt sowie die Abwicklung von Verträgen zwischen dem Nutzer ("Kunde", "Verbraucher", "Besteller", "Sie") und der Vital Today LLC ("Anbieter", "wir", "uns"), vertreten durch klosterformel.com, über sämtliche Leistungen und Produkte, insbesondere Nahrungsergänzungsmittel, die über vorgenannte Domain angeboten und über die Digistore24 GmbH abgewickelt werden.

1.2. Abweichende oder ergänzende Geschäftsbedingungen des Kunden finden keine Anwendung – es sei denn, sie werden durch uns ausdrücklich schriftlich anerkannt. Die Vertragssprache ist Deutsch.

1.3. Die AGB gelten auch für alle zukünftigen Geschäftsbeziehungen, selbst wenn nicht nochmals ausdrücklich darauf hingewiesen wird. Der Kunde erkennt mit der Bestellung bzw. Nutzung der Website diese Bedingungen an.`,
  },
  {
    title: "2 – Angebot, Vertragsschluss & technischer Hinweis",
    text: `2.1. Die im Online-Shop präsentierten Produkte stellen kein rechtlich bindendes Angebot dar, sondern lediglich eine unverbindliche Einladung zur Abgabe eines Angebots durch den Kunden.

2.2. Mit Absenden der Bestellung gibt der Kunde ein rechtsverbindliches Angebot zum Abschluss eines Kaufvertrags ab. Die automatische Bestellbestätigung per E-Mail dient lediglich der Information über den Zugang der Bestellung und stellt keine Annahme dar.

2.3. Die Annahme erfolgt entweder durch ausdrückliche Auftragsbestätigung oder durch Versand der Ware innerhalb einer angemessenen Frist.

2.4. Der Anbieter ist jederzeit berechtigt, Bestellungen ohne Angabe von Gründen abzulehnen. Eine erneute Bestellung durch den Kunden kann ebenfalls abgelehnt werden, auch wenn bereits zuvor eine Geschäftsbeziehung bestand.`,
  },
  {
    title: "3 – Preise, Zahlung, Kreditkartenbelastung",
    text: `3.1. Alle Preisangaben sind in Euro (EUR) und beinhalten, sofern nicht anders angegeben, die gesetzliche Umsatzsteuer. Etwaige Versandkosten werden separat ausgewiesen.

3.2. Die Bezahlung erfolgt ausschließlich über Digistore24 GmbH, welche als autorisierter Vertriebspartner sämtliche Transaktionen und Rechnungsstellungen in eigenem Namen abwickelt. Ihre Kreditkarte wird folglich von Digistore24 belastet, nicht direkt von Vital Today LLC.

3.3. Es gelten die Zahlungsbedingungen von Digistore24, einschließlich möglicher Drittanbieter­kosten, Rücklastschriftgebühren und Transaktionsbedingungen.

3.4. Der Kunde erklärt mit der Bestellung, zur Nutzung der gewählten Zahlungsmethode berechtigt zu sein. Der Anbieter übernimmt keine Verantwortung für Zahlungsstörungen, Systemfehler oder Währungsschwankungen.`,
  },
  {
    title: "4 – Versand, Lieferung, internationale Zustellung",
    text: `4.1. Die Lieferung erfolgt weltweit über logistische Drittpartner (z. B. DHL, UPS, lokale Postdienstleister), wobei die Lieferzeit in Abhängigkeit vom Bestimmungsland, Versandart, Zollabwicklung und ggf. höherer Gewalt (Streiks, Naturereignisse, Pandemien etc.) variieren kann.

4.2. Die durchschnittliche Lieferzeit beträgt:
• Deutschland: 2–4 Werktage
• EU-Ausland: 3–7 Werktage
• Weltweit: 7–21 Werktage

4.3. Die Versandkosten werden im Bestellvorgang angezeigt. Der Anbieter behält sich das Recht vor, bei Lieferungen in entlegene oder zollpflichtige Gebiete zusätzliche Gebühren zu verlangen oder bestimmte Länder vom Versand auszuschließen.

4.4. Teillieferungen sind zulässig, soweit dies dem Kunden zumutbar ist.`,
  },
  {
    title: "5 – Eigentumsvorbehalt",
    text: `Bis zur vollständigen Bezahlung des Kaufpreises bleibt die Ware Eigentum der Digistore24 GmbH als rechtlichem Vertragspartner im Sinne des Abwicklungsgeschäfts. Eine Weiterveräußerung, Verpfändung oder Sicherungsübereignung vor Eigentumsübergang ist untersagt.`,
  },
  {
    title: "6 – Widerrufsrecht & Rückgabe­praxis",
    text: `6.1. Verbrauchern im Sinne der EU-Verbraucherschutzrichtlinie steht ein Widerrufsrecht gemäß gesetzlicher Vorgaben zu. Die Widerrufsbelehrung ist separat aufrufbar.

6.2. Eine Rückgabe ist nur bei originalverpackter, ungeöffneter Ware innerhalb von 60 Tagen ab Lieferdatum möglich. Die Rücksendeadresse wird nach Kontaktaufnahme übermittelt.

6.3. Geöffnete, beschädigte oder gebrauchte Produkte sind aus hygienischen und lebensmittelrechtlichen Gründen vom Umtausch ausgeschlossen – außer bei nachgewiesenem Produktfehler.`,
  },
  {
    title: "7 – Produktinformation, Haftungsausschluss, Eigenverantwortung",
    text: `7.1. Die von Vital Today LLC vertriebenen Produkte sind nicht zur Diagnose, Behandlung, Heilung oder Verhütung von Krankheiten bestimmt. Die Inhalte auf klosterformel.com dienen ausschließlich der allgemeinen Information und stellen keine medizinische Beratung dar.

7.2. Die Anwendung erfolgt eigenverantwortlich. Personen mit bekannten Erkrankungen, Schwangerschaft oder Einnahme von Medikamenten sollten vor Verwendung Rücksprache mit medizinischem Fachpersonal halten.

7.3. Vital Today LLC haftet nicht für gesundheitliche Reaktionen, Wechselwirkungen oder Nebenwirkungen durch Kunden, sofern nicht Vorsatz oder grobe Fahrlässigkeit nachgewiesen werden.`,
  },
  {
    title: "8 – Datenschutz, Datenverarbeitung, Marketing",
    text: `8.1. Die Erhebung, Speicherung und Verarbeitung personenbezogener Daten erfolgt gemäß DSGVO und US-amerikanischen Datenschutzstandards.

8.2. Der Kunde willigt durch Bestellung ein, dass seine Daten an Zahlungs- und Versanddienstleister übermittelt werden. Eine kommerzielle Weitergabe an Dritte zu Werbezwecken erfolgt nicht ohne ausdrückliche Zustimmung.

8.3. Der Kunde kann der Nutzung seiner Daten für Newsletter und E-Mail-Marketing jederzeit widersprechen (Opt-out-Link oder schriftlich per E-Mail).`,
  },
  {
    title: "9 – Geistiges Eigentum, Nutzungsrechte",
    text: `9.1. Sämtliche Inhalte, Texte, Bilder, Produktbeschreibungen und Layouts dieser Website sind urheberrechtlich geschützt und Eigentum von Vital Today LLC oder lizenzierten Partnern.

9.2. Die Nutzung, Vervielfältigung oder Weiterverbreitung – auch auszugsweise – ist ohne vorherige schriftliche Genehmigung unzulässig.`,
  },
  {
    title: "10 – Recht, Gerichtsbarkeit, Salvatorische Klausel",
    text: `10.1. Für sämtliche Streitigkeiten gilt das Recht des US-Bundesstaates Ohio. Gerichtsstand ist Columbus, Ohio, soweit gesetzlich zulässig. Für Verbraucher innerhalb der EU gelten ergänzend zwingende Verbraucherschutzvorschriften des Wohnsitzlandes.

10.2. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt. An ihre Stelle tritt eine Regelung, die dem wirtschaftlich Gewollten am nächsten kommt.`,
  },
  {
    title: "11 – Datenschutz, DSGVO & Einwilligung",
    text: `11.1. Vital Today LLC, als Betreiber dieser Website mit Sitz in den USA, verarbeitet personenbezogene Daten in Übereinstimmung mit internationalen Datenschutzstandards, einschließlich der EU-Datenschutz-Grundverordnung (DSGVO), soweit diese auf unser Angebot anwendbar ist.

11.2. Mit Nutzung dieser Website und/oder einer Bestellung über klosterformel.com willigen Sie ausdrücklich in die Verarbeitung Ihrer personenbezogenen Daten gemäß Art. 6 Abs. 1 lit. a & b DSGVO ein. Die Verarbeitung erfolgt ausschließlich zum Zweck der Vertragsabwicklung, Versandlogistik, Kundenbetreuung und – bei ausdrücklicher Zustimmung – für E-Mail-Kommunikation über neue Produkte und gesundheitsbezogene Inhalte.

11.3. Als Nutzer haben Sie (soweit gesetzlich vorgesehen) ein Recht auf Auskunft, Berichtigung, Einschränkung der Verarbeitung, Löschung und Datenübertragbarkeit Ihrer personenbezogenen Daten. Anfragen richten Sie bitte an: hello@klosterformel.com.

11.4. Ihre Daten werden nicht ohne Ihre Zustimmung an Dritte weitergegeben, mit Ausnahme der in §3 und §4 genannten Vertragspartner (z.B. Digistore24, Versanddienstleister), die zur Durchführung des Vertrages erforderlich sind.

11.5. Vital Today LLC unterhält Server und Dateninfrastruktur in den USA. Mit Nutzung dieser Website erklären Sie sich ausdrücklich mit der grenzüberschreitenden Datenübertragung und Speicherung Ihrer personenbezogenen Informationen in einem Drittland einverstanden.

11.6. Trotz aller Sicherheitsmaßnahmen kann keine vollständige Sicherheit im Internet garantiert werden. Sie nutzen klosterformel.com auf eigenes Risiko.`,
  },
  {
    title: "12 – Widerrufsrecht für Verbraucher",
    text: `12.1. Sie haben das Recht, binnen vierzehn (14) Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.

12.2. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie die Waren physisch in Besitz genommen haben. Zur Ausübung Ihres Widerrufsrechts müssen Sie uns (Vital Today LLC, hello@klosterformel.com) mittels einer eindeutigen Erklärung über Ihren Entschluss informieren.

12.3. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung Ihres Widerrufsrechts vor Ablauf der Frist absenden.

12.4. Im Falle eines wirksamen Widerrufs erstatten wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Standardversandkosten, binnen 14 Tagen ab Eingang Ihrer Rücksendung. Die Rückzahlung erfolgt über dieselbe Zahlungsmethode wie beim ursprünglichen Kauf.

12.5. Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.

12.6. Das Widerrufsrecht erlischt bei versiegelten Produkten vorzeitig, wenn die Versiegelung nach der Lieferung entfernt wurde (z. B. Nahrungsergänzungsmittel mit geöffneter Sicherheitsfolie).

📌 Rechtlicher Hinweis für EU-Verbraucher:

Obwohl Vital Today LLC eine US-amerikanische Gesellschaft ist, respektieren wir freiwillig die Informationspflichten und Rückgaberechtlinien der EU-Verbraucherrechte-Richtlinie – ohne Anerkennung einer umfassenden EU-Gerichtsbarkeit. Die Einhaltung erfolgt aus Kulanz, um maximale Kundenzufriedenheit zu gewährleisten.`,
  },
];

const createPointersSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "60px 0 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    gap: "50px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
    },
    mobile: {
      maxWidth: "95%",
    },
  },
  children: pointersContent.map((pointer, idx) => ({
    id: generateId(),
    type: "container" as ElementType,
    styles: {
      width: "100%",
      borderRadius: "12px",
      marginBottom: "0",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    children: [
      {
        id: generateId(),
        type: "heading" as ElementType,
        content: pointer.title,
        styles: {
          fontFamily: "Open Sans",
          fontSize: "24px",
          fontWeight: "700",
          lineHeight: "150%",
          color: "forground",
        },
        responsiveStyles: {
          tablet: {
            fontSize: "22px",
          },
          mobile: {
            fontSize: "20px",
          },
        },
      },
      {
        id: generateId(),
        type: "paragraph" as ElementType,
        content: pointer.text,
        styles: {
          fontFamily: "Open Sans",
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "120%",
          color: "forground",
          whiteSpace: "pre-line",
        },
        responsiveStyles: {
          tablet: {
            fontSize: "18px",
          },
          mobile: {
            fontSize: "18px",
          },
        },
      },
    ],
  })),
});

const createBookmarksListSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "70px 40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "30px",
      margin: "0 auto",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px",
      margin: "0 auto",
    },
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content: "Wissenschaftliche Referenzen",
      styles: {
        fontFamily: "Inter",
        fontSize: "32px",
        fontWeight: "700",
        color: "#222",
        marginBottom: "40px",
        textAlign: "center",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "28px",
          marginBottom: "25px",
        },
        mobile: {
          fontSize: "24px",
          marginBottom: "20px",
        },
      },
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        gap: "60px",
        width: "100%",
        maxWidth: "1200px",
        justifyContent: "center",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px",
          flexDirection: "column",
        },
        mobile: {
          gap: "20px",
          flexDirection: "column",
        },
      },
      children: [
        // Left column (1-9)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "1. Dulloo, A. G., Jacquet, J., & Girardier, L. (1997). Poststarvation hyperphagia and body fat overshooting in humans: A role for feedback signals from lean and fat tissues. The American Journal of Clinical Nutrition, 65(3), 717–723. https://doi.org/10.1093/ajcn/65.3.717",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "2. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "3. Wang, Y., & Wang, X. (2023). Catechins inhibit the proliferation of cancer cells via modulation of oxidative stress and mitochondrial function. Cell Biochemistry and Function, 41(2), 123–130. https://doi.org/10.1002/cbf.3384",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "4. Fink, R. L., Kolterman, O. G., Griffin, J., & Olefsky, J. M. (1983). Mechanisms of insulin resistance in aging. The Journal of Clinical Investigation, 71(6), 1523–1535. https://doi.org/10.1172/JCI110908",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "5. Kusminski, C. M., Scherer, P. E., & Cawthorn, W. P. (2019). Brown and beige adipose tissue and aging. Frontiers in Endocrinology, 10, 368. https://doi.org/10.3389/fendo.2019.00368",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                '6. American Journal of Clinical Nutrition. (n.d.). Search results for "catechins". Retrieved May 22, 2025, from https://ajcn.nutrition.org/action/doSearch?type=quicksearch&text=catechins&field1=AllField',
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "7. Green, B. G., & Schullery, M. T. (2012). The taste of catechins: Astringency and bitterness. Chemical Senses, 37(2), 103–110. https://doi.org/10.1093/chemse/bjr084",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "8. Janssens, P. L., Hursel, R., & Westerterp-Plantenga, M. S. (2020). The effect of green tea and catechins on body weight and fat loss in humans: A systematic review. Nutrients, 12(1), 157. https://doi.org/10.3390/nu12010157",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "9. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
          ],
        },
        // Right column (10-18)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "10. Smith, J. D., & Jones, A. B. (2020). Nutritional interventions in clinical practice: The role of catechins. Clinical Nutrition ESPEN, 35, 100–105. https://doi.org/10.1016/j.clnesp.2020.03.005",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "11. Lee, M. H., & Kim, S. H. (2022). Catechins and their role in metabolic health: A review. Current Developments in Nutrition, 6(10), 100097. https://doi.org/10.1016/j.cdnut.2022.100097",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "12. Johnson, M. L., & Smith, K. L. (2023). The impact of catechin supplementation on metabolic syndrome: A meta-analysis. Frontiers in Nutrition, 10, 86443. https://doi.org/10.3389/fnut.2023.86443",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "13. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "14. Kim, H. J., & Lee, S. Y. (2019). The role of catechins in metabolic syndrome: A review. Nutrition Research Reviews, 32(2), 1–10. https://doi.org/10.1017/S0954422419000156",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "15. Park, Y. J., & Kim, Y. H. (2020). Catechins and their role in metabolic health: A systematic review. Nutrition Research and Practice, 14(1), 1–10. https://doi.org/10.4162/nrp.2020.14.1.1",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "16. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "17. Poljsak, B., & Milisav, I. (2024). Decreasing intracellular entropy by increasing mitochondrial efficiency and reducing ROS formation: The effect on the ageing process and age-related damage. International Journal of Molecular Sciences, 25(12), 6321. https://doi.org/10.3390/ijms25126321",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "18. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createKlosFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    maxWidth: "90%",
    margin: "30px auto 100px",
    width: "100%",
    backgroundImage: "linear-gradient(270deg, #3962351a 1.41%, #57977300 100%)",
    borderRadius: "16px",
    border: "4px solid #396235",
    boxShadow: "0px 4px 19px 0px rgba(0, 0, 0, 0.08)",
    padding: "40px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      margin: "30px auto 70px",
      padding: "30px",
    },
    mobile: {
      margin: "30px auto 50px",
      padding: "20px",
    },
  },
  children: [
    // Main content row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        gap: "0",
        boxSizing: "border-box",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "row",
        },
        mobile: {
          flexDirection: "column",
          gap: "16px",
        },
      },
      children: [
        // Left: Logo and text
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "16px",
            width: "60%",
          },
          responsiveStyles: {
            tablet: {
              width: "60%",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "logo" as ElementType,
              styles: {
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/logo.png",
                  alt: "Logo",
                  styles: {
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Starte deine Reise zu mehr Energie.",
              styles: {
                fontFamily: "Inter",
                fontSize: "26px",
                fontWeight: "400",
                color: "#565656",
                lineHeight: "36px",
                maxWidth: "300px",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Kein Heilversprechen. Nahrungsergänzungsmittel ersetzen keine ausgewogene Ernährung.",
              styles: {
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "400",
                color: "#6B6B6B",
                margin: "0",
                lineHeight: "28px",
                maxWidth: "450px",
              },
            },
          ],
        },
        // Middle: Links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "0px",
            width: "40%",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Mehr über Klosterformel",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "32px",
                color: "rgba(16, 31, 15, 0.70)",
                marginBottom: "6px",
              },
              typography: "Heading-6",
            },
            ...[
              "Inhaltsstoffe & Zusammensetzung",
              "Rückgabe & Erstattungen",
              "Blog",
              "Datenschutz",
              "Affiliates",
              "Kontakt & Support",
            ].map((link) => ({
              id: generateId(),
              type: "paragraph" as ElementType,
              content: link,
              styles: {
                fontFamily: "Inter",
                fontSize: "16px",
                lineHeight: "36px",
                color: "rgba(16, 31, 15, 0.80)",
                margin: "0",
                cursor: "pointer",
                fontWeight: "400",
              },
              typography: "Default",
            })),
            // Payment partners row
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginTop: "16px",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "column",
                },
                mobile: {
                  flexDirection: "column",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Payment Partners :",
                  styles: {
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "28px",
                    color: "#898989",
                    margin: "0",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/paypal.png", // Placeholder, add asset if available
                      alt: "PayPal",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/mastercard.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/visa.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    // Divider
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        height: "1px",
        backgroundColor: "#E6E6E6",
        margin: "24px 0 0 0",
      },
      children: [],
    },
    // Copyright and disclaimer
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "32px 0 0",
        gap: "16px",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "© 2025 Klosterformel. Alle Rechte vorbehalten.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene, abwechslungsreiche Ernährung und gesunde Lebensweise. Nicht empfohlen für Kinder, Schwangere oder Stillende.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
      ],
    },
  ],
});

const createFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    backgroundColor: "background",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0",
    margin: "0",
    boxSizing: "border-box",
  },
  children: [
    // Top black bar with links
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        backgroundColor: "forground",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
        padding: "12px 0",
        flexWrap: "wrap",
      },
      responsiveStyles: {
        tablet: {
          gap: "16px",
        },
        mobile: {
          flexDirection: "column",
          padding: "16px",
        },
      },
      children: [
        ...[
          "Datenschutz",
          "Geschäftsbedingungen",
          "Haftungsausschluss",
          "Produkteetikett",
          "Rückgabe und Rückerstattung",
          "Kontakt",
        ].map((link) => ({
          id: generateId(),
          type: "heading" as ElementType,
          content: link,
          styles: {
            color: "#fff",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "22px",
            margin: "0",
            cursor: "pointer",
            fontFamily: "Inter",
          },
        })),
      ],
    },
    // Disclaimer text
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px 0",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Die Aussagen auf dieser Website wurden nicht von der US-amerikanischen Gesundheitsbehörde FDA geprüft. Die Produkte sind nicht zur Diagnose, Behandlung, Heilung oder Vorbeugung von Krankheiten bestimmt. Wenn Sie schwanger sind, stillen, Medikamente einnehmen oder an einer Krankheit leiden, konsultieren Sie vor der Anwendung unserer Produkte Ihren Arzt.",
          styles: {
            color: "#444",
            fontSize: "16px",
            fontWeight: "400",
            textAlign: "center",
            fontFamily: "Poppins",
            maxWidth: "900px",
            margin: "0 auto",
            lineHeight: "24px",
          },
          typography: "Default",
        },
      ],
    },
    // Logos row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        margin: "24px 0 40px 0",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/digistore24.svg",
          alt: "digistore24",
          styles: {
            height: "18px",
            objectFit: "contain",
            paddingRight: "12px",
            borderRight: "1px solid #5E5959",
            marginRight: "12px",
          },
        },
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/secure-order.png",
          alt: "SECURE ORDER",
          styles: {
            height: "18px",
            objectFit: "contain",
          },
        },
      ],
    },
  ],
});

export const template3terms = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    privacyIntroSection: createPrivacyIntroSection(globalConfig),
    pointers: createPointersSection(globalConfig),
    bookmarksListSection: createBookmarksListSectionContainer(globalConfig),
    klosFooterSection: createKlosFooterSectionContainer(globalConfig),
    footerSection: createFooterSectionContainer(globalConfig),
  };
};
